import styled from 'styled-components';

export const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const GalleryItem = styled.img`
  width: 100%;
    height: 50px;
    @media (min-width: 768px) {
        height: auto;
    }

    @media (min-width: 1024px) {
        height: auto;
    }
  object-fit: cover;
  border-radius: 8px;
  cursor:pointer;
`;

export const ButtonRemove = styled.a`
    width: 20px;
    height: 20px;
    position: absolute;
    top: 5px;
    right: 5px;
    border-radius: 50%;
    background-color: #d85252;
    border: none;
    color: white;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: darkred;
    }
`;
